import * as Yup from 'yup';

export const validationSchema = ({ t }) =>
  Yup.object().shape({
    actualDate: Yup.string()
      .typeError(t('Actual date is required'))
      .required(t('Actual date is required')),
    actualTime: Yup.string()
      .required(t('Pickup time is required'))
      .typeError(t('Pickup time is required'))
  });

export default validationSchema;
